import { FETCH_QUERY_KEYS } from "src/queries/consts";
import { useQuery, useMutation, keepPreviousData } from "@tanstack/react-query";
import campaignManagerService from "src/queries/services/campaignManager";
import { CACHE_DURATION } from "@consts";

export const useCampaignManager = (params) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.CAMPAIGN_MANAGER, params.accountId, params.assistantId, params.paginationParams],
  queryFn: async () => await campaignManagerService.fetchCampaignManager(params),
  enabled: params.enabled && !!params.accountId && !!params.assistantId,
  staleTime: CACHE_DURATION.ONE_MINUTE,
  placeholderData: keepPreviousData
});

export const useCampaignManagerTasks = (params) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.CAMPAIGN_MANAGER_TASKS, params.accountId, params.campaignId, params.paginationParams],
  queryFn: async () => await campaignManagerService.fetchCampaignTasks(params),
  enabled: params.enabled && !!params.accountId && !!params.campaignId,
  staleTime: CACHE_DURATION.ONE_MINUTE,
  placeholderData: keepPreviousData
});

export const useAllCampaigns = (params) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.ALL_CAMPAIGNS, params.accountId],
  queryFn: async () => await campaignManagerService.fetchAllCampaigns(params),
  enabled: !!params.accountId
});

export const useCampaign = (params) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.CAMPAIGN, params.accountId, params.campaignId],
  queryFn: async () => await campaignManagerService.fetchCampaign(params),
  enabled: !!params.campaignId
});

export const useCreateCampaign = () => useMutation({ mutationFn: campaignManagerService.createCampaign });
export const useDeleteCampaign = () => useMutation({ mutationFn: campaignManagerService.deleteCampaign });
export const useUpdateCampaign = () => useMutation({ mutationFn: campaignManagerService.updateCampaign });
export const useUpdateCampaignRef = () => useMutation({ mutationFn: campaignManagerService.updateCampaignRef });

export const useOutboundFilterTypes = (params) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.OUTBOUND_FILTER_TYPES, params.accountId, params.assistantId],
  queryFn: async () => await campaignManagerService.fetchOutboundFilterTypes(params),
  enabled: !!params.accountId && !!params.assistantId,
});
